import { createContext } from 'react';

export const OrganisationContext = createContext<{
  myOrganisations: any;
  setMyOrganisations: any;
}>({ myOrganisations: null, setMyOrganisations: () => {} });
